import module from 'fan/proyecto/module.js'
import template from './template.html'

const currencyReplaceRegex = /[^0-9.-]+/g
const decodificarNumero = (value) => parseFloat(Number(value.replace(currencyReplaceRegex, '')).toFixed(2))

function Modelo () {
  this.colaborador = ''
  this.colaborador_id = null
  this.salario_diario = null
  this.salario_diario_integrado = null
  this.fecha = null
  this.notas = ''
  this.completado = false
  this.actualizado = false
  this.error = null
}

export class FanProyectoColaboradoresEditarSalarioComponent {
  constructor ($state) {
    this.$state = $state
    this.completado = false
    this.data = null
    this.error = null
    this.alertas = []
    this.step = 1
    this.idProyecto = undefined
    this.resultados = undefined
    this.modelo = Modelo
  }

  $onInit () {
    this.headers = [{
      id: 'colaborador_id',
      name: 'Colaborador ID',
      group: 'REQUERIDO',
      match: (value) => ['ID', 'COLABORADOR ID', 'COLABORADOR_ID', 'EMPLEADO_ID', 'ID_COLABORADOR', 'EMPLEADO ID', 'NOMBRE ID'].indexOf(value.toUpperCase()) >= 0,
      processor: (object, value) => {
        object.colaborador_id = value

        return object
      },
    }, {
      id: 'colaborador',
      name: 'Colaborador',
      group: 'REQUERIDO',
      match: (value) => ['COLABORADOR', 'EMPLEADO', 'NOMBRE'].indexOf(value.toUpperCase()) >= 0,
      parser: (value) => value.trim(),
      processor: (object, value) => {
        object.colaborador = value

        return object
      },
    }, {
      id: 'salario_diario',
      name: 'Salario diario',
      group: 'SALARIO',
      match: (value) => ['SALARIO', 'SALARIO DIARIO', 'SALARIO_DIARIO'].indexOf(value.toUpperCase()) >= 0,
      parser: (value) => {
        let importe = value === '' ? null : decodificarNumero(value)
        return Number.isFinite(importe) ? importe : null
      },
      processor: (object, value) => {
        object.salario_diario = value

        return object
      },
    }, {
      id: 'salario_diario_integrado',
      name: 'Salario diario integrado',
      group: 'SALARIO',
      match: (value) => ['SALARIO DIARIO INTEGRADO', 'SALARIO_DIARIO_INTEGRADO'].indexOf(value.toUpperCase()) >= 0,
      parser: (value) => {
        let importe = value === '' ? null : decodificarNumero(value)
        return Number.isFinite(importe) ? importe : null
      },
      processor: (object, value) => {
        object.salario_diario_integrado = value

        return object
      },
    }, {
      id: 'salario_neto_integral',
      name: 'Salario neto integrado',
      group: 'SALARIO',
      match: (value) => ['SALARIO_NETO_INTEGRADO', 'SALARIO NETO INTEGRADO', 'SALARIO_NETO_INTEGRAL'].indexOf(value.toUpperCase()) >= 0,
      parser: (value) => {
        let importe = value === '' ? null : decodificarNumero(value)
        return Number.isFinite(importe) ? importe : null
      },
      processor: (object, value) => {
        object.salario_neto_integral = value

        return object
      },
    }]
  }

  actualizar (data) {
    if (!data) return
    this.resultados = data
    this.resultados.forEach((item, indice) => (item.indice = indice + 1))
    this.step = 3
  }

  iniciar () {
    this.resultadosModal = this.resultados.filter((item) => !item.actualizado)
    this.completado = true
  }

  terminar (event) {
    this.completado = false
    if (event) {
      let error = event.some((item) => item.error)
      if (!error) this.$state.go('proyecto.colaboradores.lista')
      this.resultados.map((item) => {
        event.forEach((data) => {
          if (item.indice === data.indice) {
            item.error = data.error
            item.actualizado = data.actualizado
            item.completado = data.completado
          }
        })
      })
    }
  }

  importar (event) {
    this.error = null
    this.data = []
    this.alertas = []

    if (!event || !event.headers || !event.data) return

    if (event.headers.indexOf('colaborador') < 0 && event.headers.indexOf('colaborador_id') < 0) {
      return this.error = 'Especifique la columna "Colaborador" o "Colaborador ID"'
    }

    if (event.headers.indexOf('salario_diario') < 0 && event.headers.indexOf('salario_diario_integrado') < 0) {
      return this.error = 'Es necesario especificar una columna como "Salario diario" o "Salario diario integrado"'
    }

    if (event.headers.indexOf('salario_diario') > 0 && event.headers.indexOf('salario_diario_integrado') < 0) {
      return this.error = 'Al modificar el salario diario es necesario especificar el "Salario diario integrado"'
    }

    this.data = event.data.filter((item, index) => {

      if (!item.colaborador_id && !item.colaborador) {
        this.alertas.push(`Se omitirá la fila #${index + 1} pues no se especificó el nombre o ID del colaborador.`)
        return false
      }

      if (!item.salario_diario && !item.salario_diario_integrado) {
        this.alertas.push(`Se omitirá la fila #${index + 1} pues no se especificó el salario diario o salario diario integrado.`)
        return false
      }

      if (item.salario_diario_integrado <= 0) {
        this.alertas.push(`Se omitirá la fila #${index + 1} pues el salario diario integrado debe de ser mayor a cero.`)
        return false
      }

      if (event.headers.indexOf('salario_diario') > 0 && item.salario_diario !== null) {
        if (!(item.salario_diario > 1)) {
          this.alertas.push(`Se omitirá el salario diario de la fila #${index + 1} pues éste debe de ser mayor a cero.`)
          return true
        }

        let minimo = parseFloat((item.salario_diario * 1.0452).toFixed(2))
        if (item.salario_diario_integrado < minimo) {
          this.alertas.push(`Se omitirá la fila #${index + 1} pues el salario diario integrado no puede ser menor a ${minimo} ( salario diario x 1.0452 ).`)
          return false
        }

        return true
      }

      return true
    })
  }

  validar () {
    this.alertas = []
    if (this.step === 2) return

    this.step = 2
  }
}

module.component('fanProyectoColaboradoresEditarSalario', {
  controller: FanProyectoColaboradoresEditarSalarioComponent,
  template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/editar/salario/component.js